// eslint-disable-next-line no-unused-vars
import * as React from "react";
import { createContext } from "react";

export const AuthContext = createContext(false);
